
import React from 'react';
import HeaderComponent from './commonComponent/HeaderComponent';

function OurPeople() {
  return (
    <>

        <HeaderComponent title="Our People" />
   
        <div className="container-fluid py-5">
        <div className="container py-5">
            <div className="row">

                <h1>Karan Singh Jain (Advocate) (Mentor)</h1>
                
                </div>
                <br/>
                <div className="row">

                <p>Mr. Karan Singh Jain is a highly accomplished senior counsel
                  complemented with more than 65 years of standing at bar, Commissions,
                  Regulatory bodies and Tribunals. Well proficient in civil litigation, criminal
                  litigation, revenue and M.A.C.T cases since 1955. He has also worked as
                  Add. G.P. for the State Government for more than 7 years. Mr. Jain has
                  also served as a panel Advocate for OBC Bank, conducted MACT claim
                  cases for United India Insurance Co, F.C.I Gwalior and Co-operative
                  sugar factory ‘Kailaras’ as their sitting counsel. Mr. Jain has also authored
                  a Digest on revenue cases, Acquittal & Defence in Criminal Cases and
                  Digest of MACT claim cases published in 2018. Mr. Jain also received 3
                  rd Prize of his book “Acquittal & Defence in Criminal Cases” from Ministry of
                  Law and Justice in 2023.</p>
                
                </div>

            <div className="row">

                <h1>Yash Jain (B.B.A. LLB, Advocate)</h1>
                
                </div>
                <br/>
                <div className="row">
                <p>Mr. Yash completed his B.B.A. LL.B (Hons.) from ICFAI University, Dehradun in the year 2019 with
                specialization in Constitutional Law. Before moved to Gwalior, Mr. Yash was working with Singhania and
                Associates, Delhi and was primarily focusing on Consumer dispute litigation. During his more than a year
                stint with Singhania and Associates, he has gained a wide experience of rendering legal services to
                corporate and consumers. Mr. Yash is focusing on Consumer Litigation, SARFAESI, Public Interest
                Litigation, Writ, and Revenue and frequently appearing in different courts/tribunals including High Court of
                Madhya Pradesh, Consumer Disputes Redressal Commissions, Debt Recovery Tribunals, District
                Magistrate, Board of Revenue, etc.</p>
                
                </div>
                <div className="row">

                <h1>P.K. Tiwari (B.A. LLB, Advocate)</h1>
                
                </div>
                <br/>
                <div className="row">
                <p>Mr. P.K. Tiwari has been a practicing advocate since 2008 and has a wide experience in the arena of Criminal, Revenue
                and Consumer disputes. Mr. Tiwari has worked extensively on
                diversified criminal cases at all stages. In the short span of
                time as litigator, Mr. Tiwari has made his mark as an advocate
                of indomitable spirit and inimitable wit. Mr. Tiwari also
                regularly appears before Revenue Courts and specializes in
                the law and procedure of the Revenue Courts.</p>
                
                </div>
                <div className="row">

                <h1>Gautam Mishra (B.B.A. LLB, Advocate)</h1>
                
                </div>
                <br/>
                <div className="row">
                <p>Mr. Gautam Mishra completed his B.B.A. LL.B (Hons.) from ICFAI University, Dehradun with around 4 years of experience in legal affairs. Excellent argument skills with experience addressing the Supreme Court, High Court, NCLAT, NCLT, NCRDC, APTEL and other Tribunals. 
Mr. Gautam has experience in dealing with a variety of matters including SLPs, Writs, POSH Act, Cyber Crime, Consumer Disputes, Civil Disputes, Financial Matters, Insurance Matters, Recovery, Execution, Arbitration, Bail, and Section 138 of Negotiation Instrument Act, etc. He also assisted the POSH Committee established by the Indian Olympic Association.
Mr. Gautam worked as a Special Correspondent at Lawbeat, News18, worked at the chambers of senior counsel, and reported from Delhi for a legal media organisation. His flair for news and networking has been an asset to the firm.</p>
                
                </div>
                
                
        </div>
        </div>

    

    </>
  );
}

export default OurPeople;
